import type { Bloc } from '@funo/grammaire'
import type { FicheEvenement } from '../../serveur/src/evenements/index.ts'
import type { SourceCondition } from './conditions-editeur.ts'

/** Propose uniquement des faits effectivement produits par les étapes précédentes. */
export function sourcesParcours(
  blocs: Bloc[],
  fiche: Pick<FicheEvenement, 'ressources' | 'subdivisions'>,
): SourceCondition[] {
  const sources = new Map<string, SourceCondition>()
  const ajouter = (source: SourceCondition) => sources.set(source.fait, source)
  for (const bloc of blocs) {
    if (bloc.bloc === 'identite') {
      ajouter({ fait: 'demandeur.nom', nom: 'Nom du locataire', type: 'texte' })
      ajouter({ fait: 'demandeur.courriel', nom: 'Courriel', type: 'courriel' })
      if (bloc.demande_organisation)
        ajouter({ fait: 'demandeur.organisation', nom: 'Entreprise ou organisme', type: 'texte' })
      if (bloc.demande_telephone)
        ajouter({ fait: 'demandeur.telephone', nom: 'Téléphone', type: 'telephone' })
      if (bloc.demande_adresse)
        ajouter({ fait: 'demandeur.adresse', nom: 'Adresse', type: 'texte' })
    }
    if (bloc.bloc === 'identite' || bloc.bloc === 'questions') {
      for (const champ of bloc.champs) {
        if (champ.type === 'fichier') continue
        ajouter({
          fait: `${bloc.bloc === 'identite' ? 'demandeur' : 'reponses'}.${champ.cle}`,
          nom: champ.libelle,
          type: champ.type,
          options: champ.options,
        })
      }
    }
    if (bloc.bloc === 'creneau') {
      const options = fiche.ressources.flatMap((r) => {
        if (!r.cle) return []
        const subdivision = fiche.subdivisions?.find((s) => s.salle_cle === r.cle || s.sections.includes(r.cle!))
        const role = subdivision ? subdivision.salle_cle === r.cle ? ' · Salle complète' : ' · Section' : ''
        return [{ valeur: r.cle, libelle: r.nom + role }]
      })
      if (options.length) ajouter({ fait: 'ressource.cle', nom: 'Salle ou section réservée', type: 'choix', options })
      ajouter({ fait: 'reservation.quantite', nom: 'Quantité réservée', type: 'nombre' })
    }
    if (bloc.bloc === 'offres') {
      for (const option of bloc.options)
        ajouter({ fait: `offres.${bloc.cle}.${option.cle}`, nom: `Quantité · ${option.nom}`, type: 'nombre' })
    }
  }
  return [...sources.values()]
}
